module.exports = __webpack_public_path__ + "static/media/loading-icon.ae3e6c99.svg";